// extracted by css-extract-rspack-plugin
export default {"root":"TtcGil","content":"RZBs1K"};